const collapse = {
  paddingTop: '10px',
  cursor: 'pointer',
  userSelect: 'none',
};

export default { collapse };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Account/style.js